// Environments
export const DEV = process.env.NEXT_PUBLIC_VERCEL_ENV === 'development'
export const STAGING = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
export const PRO = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'

export const HOSTNAME = process.env.NEXT_PUBLIC_PROJECT_HOSTNAME
export const CLIENT_NAME = process.env.NEXT_PUBLIC_CLIENT_NAME

export const DY_COOKIE_DOMAIN = DEV ? 'localhost' : HOSTNAME

// LOCALE STUFF
export const LANG = process.env.NEXT_PUBLIC_LOCALE

export * from './httpCodes'
export * from './shuffle'
export * from './misc'
export * from './urls'
export * from './icon'
export * from './cookie'
export * from './currency'
export * from './inputAutoComplete'
export * from './inputPatterns'
export * from './inputValidations'
export * from './sortBy'
export * from './dates'
export * from './analytics'
export * from './video'
export * from './string'
export * from './phoneNumbers'
// export * from './project'
export * from './translations'
// export * from './jsonld'
export * from './motionVariants'
